import { useState } from "react";
import { SelectProduct } from "../types/salon.types";

export const useOrderManagement = () => {
  const [selectedProducts, setSelectedProducts] = useState<SelectProduct[]>([]);
  const [discount, setDiscount] = useState("0");

  const addProduct = (product: SelectProduct) => {
    setSelectedProducts(prev => {
      const existingIndex = prev.findIndex(p => p._id.$oid === product._id.$oid);
      
      if (existingIndex >= 0) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          quantity: (updated[existingIndex].quantity || 1) + 1
        };
        return updated;
      } else {
        return [...prev, { ...product, quantity: 1 }];
      }
    });
  };

  const removeProduct = (productId: string) => {
    setSelectedProducts(prev => 
      prev.filter(product => product._id.$oid !== productId)
    );
  };

  const updateProductQuantity = (productId: string, newQuantity: number) => {
    setSelectedProducts(prev =>
      prev.map(product =>
        product._id.$oid === productId
          ? { ...product, quantity: Math.max(1, newQuantity) }
          : product
      )
    );
  };

  const updateProductPrice = (productId: string, newPrice: string) => {
    setSelectedProducts(prev =>
      prev.map(product =>
        product._id.$oid === productId
          ? { ...product, Amount: newPrice }
          : product
      )
    );
  };

  const clearOrder = () => {
    setSelectedProducts([]);
    setDiscount("0");
  };

  const calculateSubtotal = () => {
    return selectedProducts.reduce((total, product) => {
      return total + parseFloat(product.amount) * (product.quantity || 1);
    }, 0);
  };

  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const discountValue = parseFloat(discount) || 0;
    return subtotal - discountValue;
  };

  return {
    selectedProducts,
    discount,
    setDiscount,
    addProduct,
    removeProduct,
    updateProductQuantity,
    updateProductPrice,
    clearOrder,
    calculateSubtotal,
    calculateTotal
  };
};